import { CommonDialogs } from "@mcleod/common";
import { Layout } from "@mcleod/components";
import { AutogenLayoutReplaceUserResultModal } from "./autogen/AutogenLayoutReplaceUserResultModal";
import { ReplaceUserErrorSlideout } from "./ReplaceUserErrorSlideout";

export class ReplaceUserResultModal extends AutogenLayoutReplaceUserResultModal {
    public static async showModal(title: string, updated:[], failed: []) {
        const modalLayout = Layout.getLayout("lme/crm/ReplaceUserResultModal") as ReplaceUserResultModal;
        const modal = CommonDialogs.createDialog(modalLayout, {
            centerInParent: true,
            title,
            panelTitleProps:{
                backgroundColor: "primary.darker",
                color: "primary.reverse"
            },
            minWidth: 350,
            movable: true
        });
        modalLayout.addLayoutLoadListener(() => {
            modalLayout.labelSuccessCount.text = updated.length.toString();
            modalLayout.labelFailCount.text = failed.length.toString();
            if (failed.length > 0) {
                modalLayout.labelFailPipe.visible = 
                modalLayout.labelViewFailed.visible = true;
                modalLayout.labelViewFailed.addClickListener(() => ReplaceUserErrorSlideout.showSlideout(failed));
            }
        });
        modal.show();
    }
}